import { useEffect } from 'react';
import { WebMap } from '../constructors';

export const useTakeLayersToTopOfMap = (layersIds: string[], webMap: WebMap | undefined) => {
    useEffect(() => {
        const layers = webMap?.layers;
        if (!webMap || !layers || layers.length === 0) {
            return;
        }

        layersIds.forEach((layerId) => {
            webMap.reorder(webMap.findLayerById(layerId), layers.length - 1);
        });
    }, [webMap, layersIds]);
};
